/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Filter_Last_YearsInputs */

const en_ui_filter_last_years = /** @type {(inputs: Ui_Filter_Last_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`last ${i?.count} years`)
};

const de_ui_filter_last_years = /** @type {(inputs: Ui_Filter_Last_YearsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`letzte ${i?.count} Jahre`)
};

/**
* | output |
* | --- |
* | "last {count} years" |
*
* @param {Ui_Filter_Last_YearsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_last_years = /** @type {((inputs: Ui_Filter_Last_YearsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Last_YearsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_last_years(inputs)
	return de_ui_filter_last_years(inputs)
});